import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';
import { DevisService, DevisRequest } from '../../services/devis.service';

@Component({
  selector: 'app-devis-sante-particulier',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, PageLayoutComponent],
  templateUrl: './devis-sante-particulier.component.html',
  styleUrl: './devis-sante-particulier.component.css'
})
export class DevisSanteParticulierComponent {
  title = 'Devis Mutuelle Santé Particulier';
  subtitle = 'Comparez les meilleures mutuelles santé';
  phoneNumber = '07 57 93 35 00';
  heroImage = 'assets/static_pages_images/the-cardiologist-henri-vaquez.jpg';
  breadcrumbs = [{ label: 'Devis Mutuelle Santé', link: undefined }];
  prevPage = { title: 'Assurance Santé Particuliers', link: '/assurance-sante-particuliers' };
  nextPage = { title: 'Contactez-nous', link: '/contact' };

  // Tab navigation
  devisTabs = [
    { label: 'Santé Particulier', route: '/devis-sante-particulier', icon: 'pi-user' },
    { label: 'Santé Professionnelle', route: '/devis-sante-professionnelle', icon: 'pi-briefcase' },
    { label: 'Emprunteur', route: '/devis-emprunteur', icon: 'pi-home' },
    { label: 'Prévoyance GAV', route: '/devis-prevoyance-gav', icon: 'pi-shield' },
    { label: 'Prévoyance IJH', route: '/devis-prevoyance-ijh', icon: 'pi-building' },
    { label: 'Prévoyance Obsèques', route: '/devis-prevoyance-obseques', icon: 'pi-heart' },
    { label: 'Prévoyance Décès', route: '/devis-prevoyance-deces', icon: 'pi-lock' },
    { label: 'Animaux', route: '/devis-animaux', icon: 'pi-star' },
    { label: 'PNO', route: '/devis-pno', icon: 'pi-building' }
  ];

  devisForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;
  errorMessage = '';

  civilites = ['M.', 'Mme', 'Mlle'];
  pays = ['France', 'Belgique', 'Suisse', 'Luxembourg', 'Monaco'];

  constructor(private fb: FormBuilder, private devisService: DevisService) {
    this.devisForm = this.fb.group({
      civilite: ['', Validators.required],
      nom: ['', [Validators.required, Validators.minLength(2)]],
      prenom: ['', [Validators.required, Validators.minLength(2)]],
      dateNaissance: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
      profession: ['', Validators.required],
      adresse: ['', Validators.required],
      codePostal: ['', [Validators.required, Validators.pattern(/^[0-9]{5}$/)]],
      ville: ['', Validators.required],
      pays: ['France', Validators.required]
    });
  }

  onSubmit() {
    if (this.devisForm.valid) {
      this.isSubmitting = true;
      this.errorMessage = '';

      const formValues = this.devisForm.value;
      const devisRequest: DevisRequest = {
        devis_type: 'Mutuelle Santé Particulier',
        civilite: formValues.civilite,
        nom: formValues.nom,
        prenom: formValues.prenom,
        date_naissance: formValues.dateNaissance,
        telephone: formValues.telephone,
        email: formValues.email,
        profession: formValues.profession,
        adresse: formValues.adresse,
        code_postal: formValues.codePostal,
        ville: formValues.ville,
        pays: formValues.pays
      };

      this.devisService.submitDevis(devisRequest).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          if (response.success) {
            this.isSubmitted = true;
          } else {
            this.errorMessage = response.message;
          }
        },
        error: (error) => {
          this.isSubmitting = false;
          this.errorMessage = error.error?.detail || 'Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer.';
          console.error('Error submitting devis:', error);
        }
      });
    } else {
      this.devisForm.markAllAsTouched();
    }
  }
}
